import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Signal, WritableSignal, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { PuntiCampionamentoService } from '../punti-campionamento.service';
import { IControlliEffettuati, IPuntoCampionamento } from '../punti-campionamento.model';
import { PosizioneGeograficaFormComponent } from '../components/forms/posizione-geografica-form/posizione-geografica-form.component';
import { DatetimeFieldComponent } from 'src/app/shared/components/fields/datetime-field/datetime-field.component';
import { ListableCardComponent } from 'src/app/shared/components/cards/listable-card/listable-card.component';
import { BooleanFieldComponent } from 'src/app/shared/components/fields/boolean-field/boolean-field.component';
import { NewFormComponent } from '../../date-controllo/components/new-form/new-form.component';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import { PuntoCampionamentoCardComponent } from '../components/punto-campionamento-card/punto-campionamento-card.component';
import { CardComponent } from 'src/app/shared/components/cards/card/card.component';
import { InformazioniFormComponent } from '../components/forms/informazioni-form/informazioni-form.component';
import { InputMapsCoordinateComponent } from 'src/app/shared/components/inputs/input-maps-coordinate/input-maps-coordinate.component';
import { AreraFormComponent } from '../components/forms/arera-form/arera-form.component';
import { AcquedottoFormComponent } from '../components/forms/acquedotto-form/acquedotto-form.component';
import { ControlliFormComponent } from '../components/forms/controlli-form/controlli-form.component';
import { MapsFieldComponent } from 'src/app/shared/components/fields/maps-field/maps-field.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { ErrorService } from 'src/app/core/services/error.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { GetMapsComponent } from 'src/app/shared/components/dialogs/get-maps/get-maps.component';
import { GetMapsEditComponent } from 'src/app/shared/components/dialogs/get-maps-edit/get-maps-edit.component';
import { MyDialogComponent } from '../components/my-dialog/my-dialog.component';
import { MyDialogControlliComponent } from '../components/my-dialog-controlli/my-dialog-controlli.component';
import { ScreenService } from 'src/app/core/services/screen.service';
import { PUNTI_CAMPIONAMENTO_COLUMNS, PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE, PUNTICAMPIONAMENTO_VISIBLECOLUMNS } from '../punti-campionamento.config';
import { ITableColumn } from 'src/app/core/models/table.model';
import { TableComponent } from "../../../shared/components/table/table.component";
import {NgxPrintModule} from 'ngx-print';
import {MatButtonModule} from '@angular/material/button';
import { PageListComponent } from "../../../layout/pages/page-list/page-list.component";
import { PuntiCampionamentoStoricoService } from '../punti-campionamento-storico.service';
import { CONTROLLO_DETTAGLIO_COLUMNS } from '../controlli-dettaglio.config';
import { ControlloDettaglioService } from '../controllo-dettaglio.service';
@Component({
  selector: 'app-punticampionamento-dettaglio-page',
  standalone: true,
  imports: [
    CommonModule,
    PageDetailComponent,
    CardComponent,
    NgxPrintModule,
    MatButtonModule,
    EditableCardComponent,
    MatTooltipModule,
    MatIconModule,
    ListableCardComponent,
    TextFieldComponent,
    DatetimeFieldComponent,
    BooleanFieldComponent,
    MapsFieldComponent,
    PuntoCampionamentoCardComponent,
    AreraFormComponent,
    AcquedottoFormComponent,
    InformazioniFormComponent,
    ControlliFormComponent,
    PosizioneGeograficaFormComponent,
    NewFormComponent,
    InputMapsCoordinateComponent,
    TableComponent,
    PageListComponent
],
  templateUrl: './dettaglio-page.component.html',
  styleUrl: './dettaglio-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DettaglioPageComponent {
  datiControlli:WritableSignal<IControlliEffettuati[]>=signal([]);
  columnsControlli: ITableColumn[] = CONTROLLO_DETTAGLIO_COLUMNS;
  datiStorico:Signal<IPuntoCampionamento[]>=signal([]);
  columnsDatiStorico: ITableColumn[] = PUNTI_CAMPIONAMENTO_COLUMNS;
  @Input() id = '0';
  visibleColumns = signal(PUNTICAMPIONAMENTO_VISIBLECOLUMNS);
  errorMessage=[''];
  checkisWithinIstatComune=false
  checkPrint=false
  shapeComune:any;
  insertForm: FormGroup;
  form: FormGroup;
  model: WritableSignal<IPuntoCampionamento| undefined> = signal(undefined);
  reload: EventEmitter<any> = new EventEmitter<any>();
  hasCoordinate = signal(false);
  // coordinate = computed(() => this.form.get(this.name)?.value)
  coordinate: WritableSignal<google.maps.LatLngAltitudeLiteral | null> = signal(null);
  constructor(
    private readonly fb: FormBuilder,
    public readonly service: PuntiCampionamentoService,
    public readonly serviceStorico: PuntiCampionamentoStoricoService,
    private dialogService: DialogService,
    private screen: ScreenService,
    private cdr : ChangeDetectorRef,
    public readonly controlloDettaglioService: ControlloDettaglioService,
  ) {
    this.insertForm = this.fb.group<IPuntoCampionamento>(<IPuntoCampionamento>{});
    this.form = this.fb.group({});
    this.form.valueChanges.subscribe(value=>this.checkFormValidity())
  }
  async ngOnInit() {
    this.form.addControl('coordinateMaps', new FormControl(null, []));
  



  }

  checkModel(){
    this.serviceStorico.query.store.setKey("filters", {"id.equals": this.model()?.id })
    console.log(this.model())
     this.controlloDettaglioService.getControlliDettaglio(this.model()?.uuid).subscribe((val:any)=> {
       this.datiControlli.set(val)
       
       if(val.length>0){
        this.checkPrint=true
       }
    
      });
      if(!this.model()?.isWithinIstatComune){
        this.controlloDettaglioService.getGeoJsonComune(this.model()?.comune?.istatComune!).subscribe((el)=>{
          this.shapeComune=el
          this.checkisWithinIstatComune=true
       
        })

      }
  }
  checkFormValidity() {
    this.errorMessage=['']
    for (const control in this.form.controls) {
      if (this.form.controls.hasOwnProperty(control)) {
        const formControl = this.form.get(control);
        if (formControl && formControl.invalid) {
          var datoErroreDettaglio = control.replace("Id", "").replace("id", "").trim()
          this.errorMessage.push(`${datoErroreDettaglio} non ha un valore corretto`)
        }
      }
    }
  }
  showDialog(): void {
    const dialogRef = this.dialogService.open(MyDialogComponent, {
      data: {
        title:"Errori",
        message:this.errorMessage
      },
    
    })

    dialogRef.afterClosed().subscribe(() => {

    })
  }

  showDialogControlli(): void {

    const dialogRef = this.dialogService.open(MyDialogControlliComponent, {
      data: {
        title:"Controlli",
        idPuntoCampionamento:this.model()?.uuid
      },     
    }, this.screen.lowerThen('sm') ? '100%' : '1000px')

    dialogRef.afterClosed().subscribe(() => {

    })
  }
  customActionClick:Function=(el:any)=>{
    if(!this.model()?.isDateValid){
      return
    }
    const dialogRef = this.dialogService.open(GetMapsEditComponent, {
      data: {
        coordinate:  this.model()?.coordinateMaps,
        crud: this.service,
        model:this.model,
        modelId:this.model()?.uuid,
        isSave:true,
        formSave:this.form
      }
    }, this.screen.lowerThen('sm') ? '100%' : '1000px');

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.model.set(result)
        /*this.form.get('coordinateMaps')?.patchValue(result);
        this.form.get('coordinateMaps')?.markAsTouched();
        this.form.get('coordinateMaps')?.markAsDirty();*/
      }
    });

  }

}
